<template>
  <div>
    <order-type-list v-show="activeKey===1" ref="list" :operation-types="operationTypes" :order-types="orderTypes" @config="config"/>
    <order-type-extra v-show="activeKey===2" ref="extra" :flow-types="flowTypes" :inventory-states="inventoryStates" :number-types="numberTypes" :owners="owners" :roles="roles" :warehouses="warehouses" @back="back"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import OrderTypeList from '@/views/basedata/orderType/OrderTypeList.vue'
import OrderTypeExtra from '@/views/basedata/orderType/OrderTypeExtra.vue'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'OrderTypeManagement',
  components: { OrderTypeList, OrderTypeExtra },
  data() {
    return {
      activeKey: 1,
      orderTypes: [],
      operationTypes: [],
      inventoryStates: [],
      numberTypes: [],
      warehouses: [],
      owners: [],
      roles: [],
      flowTypes: []
    }
  },
  created() {
    findAll('orderTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.orderTypes = getOptions(res.result)
      }
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
      return getEnums('InventoryState')
    }).then(result => {
      this.inventoryStates = result
      return getEnums('NumberType')
    }).then(result => {
      this.numberTypes = result
      return findAll('warehouseFactory', {})
    }).then(res => {
      if (res.success) {
        this.warehouses = getOptions(res.result)
      }
      return findAll('partyFactory', { available: true, 'type.ordinal': 1 })
    }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return findAll('roleFactory', { available: true })
    }).then(res => {
      if (res.success) {
        this.roles = getOptions(res.result)
      }
      return getEnums('FlowType')
    }).then(result => {
      this.flowTypes = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    config(type) {
      this.activeKey = 2
      this.$refs.extra.refresh(type)
    }
  }
}
</script>